import BaseService from '@/services/base_service';

export default class ReminderService extends BaseService {
    list(params) {
        return new Promise((resolve, reject) => {
            axios.get('/lembrete/' + params, params).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }

    create(reminder) {
        return new Promise((resolve, reject) => {
            axios.post('/lembrete', reminder).then(response => {
                resolve(response);
            }).catch(e => {
                reject(this.getErrors(e));
            });
        });
    }

    delete(id) {
        return new Promise((resolve, reject) => {
            axios.delete('/lembrete/' + id).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/reminder.js